import { differenceInCalendarDays, differenceInMinutes, format, parseISO } from 'date-fns';

export const formatPipelineElapsed = (timestamp: string, now: Date): string => {
    const minutes = Math.max(0, differenceInMinutes(now, parseISO(timestamp)));
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    if (hours === 0) return `${minutes}m`;
    if (remainingMinutes === 0) return `${hours}h`;
    return `${hours}h ${remainingMinutes}m`;
};

export const formatPipelineStatusDate = (timestamp: string, now: Date): string => {
    const date = parseISO(timestamp);
    const daysFromToday = differenceInCalendarDays(date, now);
    const time = format(date, 'HH:mm');

    if (daysFromToday === -1) return `Yesterday ${time}`;
    if (daysFromToday === 0) return `Today ${time}`;
    if (daysFromToday === 1) return `Tomorrow ${time}`;
    if (Math.abs(daysFromToday) <= 7) return format(date, 'EEEE HH:mm');
    return format(date, 'dd MMM HH:mm');
};
